import { expValEquals } from '@atlassian/jira-feature-experiments';
import type { JiraSoftwareNavData } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/project-sidebar-navigation/types.tsx';
import type { Features } from './types.tsx';

export const extractData = (data: JiraSoftwareNavData): Features => {
	const {
		aiInfo,
		hasBacklog,
		hasBoard,
		hasCalendar,
		hasCode,
		hasComponents,
		hasDeployments,
		hasDevelopment,
		hasForms,
		hasGoals,
		hasIncidents,
		hasIssues,
		hasList,
		hasOpsgenieSchedule,
		hasPages,
		hasReleases,
		hasReports,
		hasRequests,
		hasRoadmap,
		hasSecurity,
		hasSummaryPage,
		permissionInfo,
		hasArchivedIssues = false,
	} = data;
	const isProjectOrSiteAdmin =
		permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
	const hasEditWorkflowPermissions =
		permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
	const hasEditIssueLayoutPermissions =
		permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;

	return {
		hasArchivedIssues,
		hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true,
		hasBacklog,
		hasBoard,
		hasCalendar,
		hasCode,
		hasComponents,
		hasDeployments,
		hasDevelopment,
		hasForms: expValEquals('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
		hasGoals,
		hasIncidents,
		hasIssues,
		hasList: expValEquals('jsw_list_view', 'cohort', 'variation') ? hasList : false,
		hasOpsgenieSchedule,
		hasPages,
		hasReleases,
		hasReports,
		hasRequests,
		hasRoadmap,
		hasSecurity,
		hasSettings:
			isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions,
		hasShortcutsAdd: isProjectOrSiteAdmin,
		hasSummaryPage,
	};
};
